import { defineMessages } from 'react-intl';

export default defineMessages({
    alertTitle: {
        id: "twia.quoteandbind.cp.buildingsWizard.EditLocation.Alert Title",
        defaultMessage: "You are editing a location used for {buildingsCount} and the changes you make here will apply to all of them."
    },
    changeLocation: {
        id: "twia.quoteandbind.cp.views.building.changeLocation",
        defaultMessage: "If you want to change the location for individual building, proceed as follows:"
    },
    expandLocation: {
        id: "twia.quoteandbind.cp.views.building.expandLocation",
        defaultMessage: "Expand \"Location\" and choose either new or existing location."
    },
    selectBuilding: {
        id: "twia.quoteandbind.cp.views.building.selectBuilding",
        defaultMessage: "Select the building."
    },
})